import arEG from 'antd/lib/locale-provider/ar_EG';
import enUS from 'antd/lib/locale-provider/en_US';

export const DEFAULT_LANGUAGE = 'en';

export const DATE_LOCALES = {
  en: { moment: 'en', antd: enUS },
  ar: { moment: 'ar', antd: arEG },
};
